import React from "react";
import { Layout } from "antd";
import {version} from '../../package.json';
const { Footer } = Layout;

// REACT_APP_ENVIRONMENT e lido em tempo de BUILD (mesma convencao do
// REACT_APP_API_URL em Services/index.js). So passa em builds de staging;
// sem a variavel, o rodape fica igual ao de producao (sem sufixo).
const environmentLabel = process.env.REACT_APP_ENVIRONMENT
  ? ` [${process.env.REACT_APP_ENVIRONMENT.toUpperCase()}]`
  : '';

const VersionComponent = () => {
    const today = new Date();
    const year = today.getFullYear();

  return (
    <Footer
      style={{
        borderTop: "1px",
        position: "fixed",
        left: 0,
        bottom: 0,
        width: "100%",
        textAlign: "center",
      }}
    >
      Polibras Software ©{year} - v{version}{environmentLabel}
    </Footer>
  );
};

export default VersionComponent;
